import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipoInsucessosComponent } from './tipo-insucessos.component';
import { TranslateModule } from '@ngx-translate/core';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { ComumModule } from '../../../shared/comum.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { TipoInsucessoService } from './tipo-insucesso-service/tipo-insucesso.service';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ComumModule,
    TooltipModule,
    DialogModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  declarations: [
    TipoInsucessosComponent
  ],
  providers: [
    TipoInsucessoService
  ]
})
export class TipoInsucessosModule { }
